import { render, staticRenderFns } from "./InsuranceSummary.vue?vue&type=template&id=69984a12"
import script from "./InsuranceSummary.vue?vue&type=script&lang=js"
export * from "./InsuranceSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports